import { sumItems } from '@voll-intelligence/intelligence-ui-kit/checkout';
import type { CheckoutCardSlots } from '../../ui/card_slots.js';
import { SummaryFoot } from '../../ui/summary_foot.js';
import { oneClickLive, travelsAlone } from '../checkout_loyalty.js';
import { FlightCheckoutLegs, type FlightCheckoutItem } from './checkout_legs.js';
import { FlightCheckoutLoyalty } from './checkout_loyalty.js';

/** O card do aéreo: os trechos, a conferência do 1-Click, a fidelidade de quem
 *  viaja sozinho e o rodapé por pessoa — a tarifa é por assento, e cada trecho
 *  mostra a sua na régua. */
export function FlightCheckoutCard({
  items,
  slots,
}: {
  readonly items: readonly FlightCheckoutItem[];
  readonly slots: CheckoutCardSlots;
}) {
  const { checkout, flow } = slots;
  return (
    <>
      <div className="checkout__body">
        <FlightCheckoutLegs items={items} />
      </div>
      {slots.review}
      <FlightCheckoutLoyalty
        items={items}
        self={travelsAlone(checkout)}
        record={!oneClickLive(flow)}
      />
      {slots.travelDocs}
      <SummaryFoot
        valueKey="common.perPerson"
        value={sumItems(items)}
        inPolicy={flow.withinPolicy}
        shieldAriaKey="productCheckout.flight.outOfPolicyAria"
        shieldTitleKey="productCheckout.outOfPolicy"
        actions={slots.actions('productCheckout.reserveFlight')}
      />
    </>
  );
}
